export const mockData = {
  hero: {
    title: "Building Websites That",
    highlight: "Drive Business Growth",
    description: "Transforming ideas into powerful digital experiences. From sleek landing pages to complex web applications with booking systems, crafting solutions that convert visitors into customers.",
    cta: "See the Work"
  },
  capabilities: [
    {
      id: 1,
      title: "Custom Web Development",
      description: "Tailored websites built from the ground up with modern technologies. Fast, responsive, and optimized for conversions.",
      features: ["React & Next.js", "Performance Optimization", "SEO Ready"],
      video: null // Add video URL here later
    },
    {
      id: 2,
      title: "Booking & Scheduling Systems",
      description: "Fully functional booking calendars with real-time availability, automated confirmations, and seamless integration with your workflow.",
      features: ["Calendar Integration", "Auto Confirmations", "Payment Processing"],
      video: null // https://streamable.com/dea9iq
    },
    {
      id: 3,
      title: "E-Commerce Solutions",
      description: "Full-featured online stores with seamless checkout experiences, inventory management, and payment integration.",
      features: ["Secure Payments", "Inventory Systems", "Analytics Dashboard"],
      video: null
    },
    {
      id: 4,
      title: "Landing Pages",
      description: "High-converting landing pages designed to capture leads and drive action. A/B tested and conversion-optimized.",
      features: ["Conversion Focused", "Fast Load Times", "Mobile First"],
      video: null
    },
    {
      id: 5,
      title: "Web Applications",
      description: "Complex web apps with robust backends. User authentication, databases, APIs, and real-time features.",
      features: ["Full Stack", "Cloud Hosting", "Scalable Architecture"],
      video: null
    },
    {
      id: 6,
      title: "UI/UX Design",
      description: "Beautiful interfaces that users love. Every interaction thoughtfully designed for maximum engagement.",
      features: ["User Research", "Prototyping", "Design Systems"],
      video: null
    }
  ],
  portfolio: [
    {
      id: 1,
      title: "MediCare Booking Platform",
      category: "Booking System",
      description: "Complete appointment scheduling system for healthcare providers with calendar sync, automated reminders, and patient management.",
      technologies: ["React", "Node.js", "MongoDB", "Google Calendar API"],
      imageUrl: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80"
    },
    {
      id: 2,
      title: "TechStart SaaS Platform",
      category: "Web Application",
      description: "A complete SaaS platform with user authentication, subscription management, and analytics dashboard.",
      technologies: ["React", "Node.js", "MongoDB", "Stripe"],
      imageUrl: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
    },
    {
      id: 3,
      title: "Luxe Fashion E-Commerce",
      category: "E-Commerce",
      description: "Modern online boutique with advanced filtering, wishlist functionality, and seamless checkout.",
      technologies: ["Next.js", "Shopify", "TailwindCSS"],
      imageUrl: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&q=80"
    },
    {
      id: 4,
      title: "Salon Booking & Management",
      category: "Booking System",
      description: "Full-featured salon booking platform with staff scheduling, service packages, and client history tracking.",
      technologies: ["React", "FastAPI", "PostgreSQL", "Stripe"],
      imageUrl: "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=800&q=80"
    }
  ],
  process: [
    {
      id: 1,
      step: "Discovery",
      description: "Deep dive into your business goals, target audience, and project requirements."
    },
    {
      id: 2,
      step: "Design",
      description: "Creating wireframes and high-fidelity designs that align with your brand identity."
    },
    {
      id: 3,
      step: "Development",
      description: "Building your site with clean code, modern frameworks, and best practices."
    },
    {
      id: 4,
      step: "Launch",
      description: "Testing, optimization, and deployment. Then monitoring and refining for success."
    }
  ],
  technologies: [
    { name: "React", category: "Frontend" },
    { name: "Next.js", category: "Framework" },
    { name: "TailwindCSS", category: "Styling" },
    { name: "Node.js", category: "Backend" },
    { name: "Python", category: "Backend" },
    { name: "FastAPI", category: "Backend" },
    { name: "MongoDB", category: "Database" },
    { name: "PostgreSQL", category: "Database" },
    { name: "AWS", category: "Cloud" },
    { name: "Vercel", category: "Deployment" }
  ],
  stats: [
    { value: "30+", label: "Projects Delivered" },
    { value: "100%", label: "Client Satisfaction" },
    { value: "24/7", label: "Support Available" }
  ]
};
